var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 39,
    viewBox: "0 0 34 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0833 4.91667H6.25C5.69747 4.91667 5.16756 5.13616 4.77686 5.52686C4.38616 5.91756 4.16667 6.44747 4.16667 7V32C4.16667 32.5525 4.38616 33.0824 4.77686 33.4731C5.16756 33.8638 5.69747 34.0833 6.25 34.0833H27.0833C27.6359 34.0833 28.1658 33.8638 28.5565 33.4731C28.9472 33.0824 29.1667 32.5525 29.1667 32V7C29.1667 6.44747 28.9472 5.91756 28.5565 5.52686C28.1658 5.13616 27.6359 4.91667 27.0833 4.91667ZM6.25 0.75C4.5924 0.75 3.00269 1.40848 1.83058 2.58058C0.65848 3.75269 0 5.3424 0 7V32C0 33.6576 0.65848 35.2473 1.83058 36.4194C3.00269 37.5915 4.5924 38.25 6.25 38.25H27.0833C28.7409 38.25 30.3306 37.5915 31.5028 36.4194C32.6749 35.2473 33.3333 33.6576 33.3333 32V7C33.3333 5.3424 32.6749 3.75269 31.5028 2.58058C30.3306 1.40848 28.7409 0.75 27.0833 0.75H6.25Z",
    fill: "#4EB9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 9.08594H25.0002V13.2526H8.3335V9.08594ZM8.3335 17.4193H25.0002V21.5859H8.3335V17.4193ZM8.3335 25.7526H18.7502V29.9193H8.3335V25.7526Z",
    fill: "#4EB9FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcIcon);
export default __webpack_public_path__ + "static/media/T&CIcon.4458ac82874cf03b058c568ff43401c3.svg";
export { ForwardRef as ReactComponent };